import styled from 'styled-components';

export const FlatList = styled.div`
	max-height: ${({ maxHeight }) => maxHeight ? `${maxHeight}px` : 'auto'};
	overflow-y: ${({ maxHeight }) => maxHeight ? 'auto' : 'none'};
`;
